"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcknowledgeRemindersDisclaimer = exports.useAssistedUserActivation = exports.useAssistedUser = exports.useForgotEmail = exports.useGetAnnouncements = exports.useUnsubscribeFromPushNotifications = exports.useSubscribeToPushNotifications = exports.useResendCode = exports.useRegisterVerification = exports.useRegisterSelection = exports.useChangePharmacy = exports.useResetPassword = exports.useForgotPassword = exports.useUpdateUser = exports.useRegisterNewUser = exports.useRegister = exports.useDeleteUser = exports.useChangePassword = void 0;
var user_1 = require("../user");
var react_query_1 = require("react-query");
function useChangePassword(options) {
    return (0, react_query_1.useMutation)(user_1.changePassword, options);
}
exports.useChangePassword = useChangePassword;
function useDeleteUser(options) {
    return (0, react_query_1.useMutation)(user_1.deleteUser, options);
}
exports.useDeleteUser = useDeleteUser;
function useRegister(options) {
    return (0, react_query_1.useMutation)(user_1.register, options);
}
exports.useRegister = useRegister;
function useRegisterNewUser(options) {
    return (0, react_query_1.useMutation)(user_1.registerNewUser, options);
}
exports.useRegisterNewUser = useRegisterNewUser;
function useUpdateUser(options) {
    return (0, react_query_1.useMutation)(user_1.updateUser, options);
}
exports.useUpdateUser = useUpdateUser;
function useForgotPassword(options) {
    return (0, react_query_1.useMutation)(user_1.getForgotPassword, options);
}
exports.useForgotPassword = useForgotPassword;
function useResetPassword(options) {
    return (0, react_query_1.useMutation)(user_1.postForgotPassword, options);
}
exports.useResetPassword = useResetPassword;
function useChangePharmacy(options) {
    return (0, react_query_1.useMutation)(user_1.changePharmacy, options);
}
exports.useChangePharmacy = useChangePharmacy;
function useRegisterSelection(options) {
    return (0, react_query_1.useMutation)(user_1.registerSelection, options);
}
exports.useRegisterSelection = useRegisterSelection;
function useRegisterVerification(options) {
    return (0, react_query_1.useMutation)(user_1.registerVerification, options);
}
exports.useRegisterVerification = useRegisterVerification;
function useResendCode(options) {
    return (0, react_query_1.useMutation)(user_1.resendCode, options);
}
exports.useResendCode = useResendCode;
function useSubscribeToPushNotifications(options) {
    return (0, react_query_1.useMutation)(user_1.subscribeToPushNotifications, options);
}
exports.useSubscribeToPushNotifications = useSubscribeToPushNotifications;
function useUnsubscribeFromPushNotifications(options) {
    return (0, react_query_1.useMutation)(user_1.unsubscribeFromPushNotifications, options);
}
exports.useUnsubscribeFromPushNotifications = useUnsubscribeFromPushNotifications;
function useGetAnnouncements() {
    return (0, react_query_1.useQuery)(["getAnnouncements"], user_1.getAnnouncements);
}
exports.useGetAnnouncements = useGetAnnouncements;
function useForgotEmail(options) {
    return (0, react_query_1.useMutation)(user_1.forgotEmail, options);
}
exports.useForgotEmail = useForgotEmail;
function useAssistedUser(options) {
    return (0, react_query_1.useMutation)(user_1.getAssistedUser, options);
}
exports.useAssistedUser = useAssistedUser;
function useAssistedUserActivation(options) {
    return (0, react_query_1.useMutation)(user_1.assistedUserActivation, options);
}
exports.useAssistedUserActivation = useAssistedUserActivation;
function useAcknowledgeRemindersDisclaimer(options) {
    return (0, react_query_1.useMutation)(user_1.acknowledgeRemindersDisclaimer, __assign({}, options));
}
exports.useAcknowledgeRemindersDisclaimer = useAcknowledgeRemindersDisclaimer;
